export default class BTagList
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-tag-list`;

	setTag(tagId)
	{
		this.resetTag();

		const tags = this.el.querySelectorAll(`[data-tag-id="${tagId}"]`);
		if (tags.length) {
			tags.forEach(tag => {
				tag.classList.add("b-tag--active");
			});
		} else {
			this.el.querySelectorAll(`.b-tag--all`).forEach(tag => {
				tag.classList.add("b-tag--active");
			});
		}
	}

	resetTag()
	{
		this.el.querySelectorAll(`.b-tag--active`).forEach(el => {
			el.classList.remove("b-tag--active");
		});
	}
}
